// Central WhatsApp deep-link helper. Number pulled from env (fallback to ops number).
const WA_NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || "919004398004").replace(/\D/g, "");

export function waLink(text) {
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}

export function waNumberDisplay() {
  const n = WA_NUMBER;
  return `+${n.slice(0, 2)} ${n.slice(2, 6)} ${n.slice(6)}`;
}

export const WA_NUMBER_RAW = WA_NUMBER;
